import { mapStoreLocale } from "../utils/network.mjs";
import { print, stripIgnoredCharacters } from "graphql";
export function normalizeQuery(query) {
  if (typeof query === "string") {
    return query;
  }
  if (query && query.kind) {
    return stripIgnoredCharacters(print(query));
  }
  return null;
}
export function localePlugin(locale, _mapStoreLocale = mapStoreLocale) {
  const appTarget = "";
  return function localePlugin2({ opContext }) {
    opContext.headers["Content-Language"] = locale;
    opContext.headers.Store = `${appTarget}${_mapStoreLocale(locale)}`;
  };
}
